import React from "react";
import BodyText from "../../elements/body-text";
import SummaryBlock from "../pdp-order-summary/components/SummaryBlock";
import PriceBreakdownBlock from "../pdp-order-summary/components/PriceBreakdownBlock";
import { planType } from "../../utils/lynkco-constants";
const PdpOrderSummaryInfo = ({ fields, loanTermsAndConditions, itemList = null, featureList = [], total = 0, priceList = [], disclaimerValue }) => {
  const { disclaimerMtM, disclaimerBaC } = fields;

  return (
    <div className="pdp-order-summary-info">
      {itemList && itemList.items && (
        <SummaryBlock {...itemList}>
          <ul>
            {itemList.items.map((item, itemIndex) => {
              return (
                <li className="body-small" key={itemIndex}>
                  <span>[</span>
                  <div className="white quantity">{item.quantity}</div>
                  <span>]</span>
                  <span className="white truncate">{item.name}</span>
                </li>
              );
            })}
          </ul>
        </SummaryBlock>
      )}
      {featureList &&
        featureList.map((section, sIndex) => {
          return (
            <SummaryBlock {...section} key={sIndex}>
              <ul>
                {section.items.map((item, index) => {
                  return (
                    <li className="flex-block" key={index}>
                      <p className="body-small">{item.title}</p>
                      <p className="body-small white">{item.value}</p>
                    </li>
                  );
                })}
              </ul>
            </SummaryBlock>
          );
        })}
      <div className="feature-container" />
      {priceList &&
        priceList.map((header, hIndex) => {
          return (
            <React.Fragment key={hIndex}>
              <div className="price-breakdown-container">
                <PriceBreakdownBlock items={[{ title: header.title, value: header.value }]} key={hIndex} additionalClass={"-no-margin"} />
              </div>
              {header.items && (
                <div className={"summary-block -no-border"}>
                  <div className="block-grid -big">
                    <div className="block-content">
                      <ul>
                        {header.items.map((item, index) => {
                          return (
                            <React.Fragment key={index}>
                              <li className="flex-block" key={`${item.title}${index}`}>
                                <BodyText tagName={"p"} html={item.title} className="body-small" />
                                {item.disclaimer ? (
                                  <div className="footnote-container">
                                    <BodyText html={item.value} className="body-small" />
                                    <p className="footnote">{item.footnote}</p>
                                  </div>
                                ) : (
                                  <p className="body-small">{item.value}</p>
                                )}
                              </li>
                              {item.disclaimer && (
                                <li className="flex-block" key={`${item.disclaimer}${index}`}>
                                  <BodyText html={item.disclaimer} className="caption -no-margin" />
                                </li>
                              )}
                            </React.Fragment>
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                </div>
              )}
            </React.Fragment>
          );
        })}
      {/* return (
              <>
                {index > 1 && item.value !== "" && (
                  <div className={"summary-block"}>
                    <div className="block-grid">
                      <div className="block-content">
                        <ul>
                          <li className="flex-block" key={index}>
                            <p className="body-small">{item.title}</p>
                            <p className="body-small white">{item.value}</p>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                )}
                {item.value && item.disclaimer && (
                  <div className={"summary-block"}>
                    <div className="block-grid">
                      <div className="block-content">
                        <ul>
                          <li className="flex-block" key={index}>
                            <p className="body-small">
                              <BodyText html={item.disclaimer} className="caption" />
                            </p>
                            <p className="body-small white"></p>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                )}
              </>
            ); */}

      {total && (
        <div className="flex-block">
          <h4 className="type-h4">{total.title}</h4>
          <h4 className="type-h4">{total.value}</h4>
        </div>
      )}
      {disclaimerValue === planType.MtM ? <BodyText className="caption gray" html={disclaimerMtM} /> : <BodyText className="caption gray" html={disclaimerBaC} />}
      <BodyText className="caption gray" html={loanTermsAndConditions} />
    </div>
  );
};
export default PdpOrderSummaryInfo;
